module.exports = __webpack_public_path__ + "static/media/emotions-why-core.e25e0242.png";